import SelfServeTooltipTourConstants from './TooltipTourConstants';
import { TOOLBOX_TOOLTIPS } from './TooltipTourConstants';

export const hideAllPreviewTips = () => (
  (dispatch) => {
    dispatch({
      type: SelfServeTooltipTourConstants.PREVIEW_TOOLTIP_HIDE_ALL,
    });
  }
);

export const hideCurrentToolboxTip = tooltipName => (
  (dispatch) => {
    dispatch({
      type: SelfServeTooltipTourConstants.TOOLBOX_TOOLTIP_HIDE_CURRENT,
      tooltip: tooltipName,
    });
  }
);

export const hideAllToolboxTips = () => (
  (dispatch) => {
    dispatch({
      type: SelfServeTooltipTourConstants.TOOLBOX_TOOLTIP_HIDE_ALL,
    });
  }
);

export const showToolboxTip = tooltipName => (
  (dispatch) => {
    dispatch({
      type: SelfServeTooltipTourConstants.TOOLBOX_TOOLTIP_SHOW,
      tooltip: tooltipName,
    });
  }
);

export const showNextTip = () => (
  (dispatch) => {
    dispatch({
      type: SelfServeTooltipTourConstants.TOOLTIP_NEXT,
    });
  }
);

export const showPreviewButtonTip = () => (
  (dispatch) => {
    dispatch({
      type: SelfServeTooltipTourConstants.PREVIEW_BUTTON_TOOLTIP_SHOW,
    });
  }
);

export const setTooltipLocation = (tipOutlineRectangle, tooltipName) => (
  (dispatch) => {
    const isToolboxType = TOOLBOX_TOOLTIPS.indexOf(tooltipName) > -1;
    if (isToolboxType) {
      dispatch({
        type: SelfServeTooltipTourConstants.TOOLBOX_TOOLTIP_LOCATION_SET,
        tipLocationOutline: tipOutlineRectangle,
        tooltip: tooltipName,
      });
    }
  }
);



// WEBPACK FOOTER //
// ./src-react/SelfServeTooltipTour/TooltipTourActions.jsx